/** "Try a free demo": a student asks, admin approves and arranges a class on any topic. */
import { api } from '../../core/api.js';
import { register } from '../../core/events.js';
import { html } from '../../core/html.js';
import { fmtDate } from '../../core/format.js';
import { reload } from '../../app/shell.js';
import { ic, statusTag } from '../../ui/components.js';
import { field } from '../../ui/forms.js';
import { closeModal, openModal } from '../../ui/modal.js';
import { submitForm } from '../../ui/submit.js';
import { toast } from '../../ui/toast.js';

export const loadDemos = (signal) => api.get('/student/demo-requests', { signal }).then((d) => d.requests).catch(() => []);

export function demoCard(requests) {
  const open = requests.some((r) => r.status === 'requested');
  return html`<div class="card tint"><div class="row between"><div><h3 style="margin:0">Try a free demo class</h3>
      <p class="sm mu" style="margin:4px 0 0">Not sure yet? Tell us what you want to try. Once approved, we arrange a free class on that topic and add you to it.</p></div>
      <button type="button" class="btn" data-act="demo.ask" ${open ? 'disabled' : ''}>${ic('play')} Ask for a free demo</button></div>
    ${requests.length ? html`<div class="list sm mt-s">${requests.slice(0, 3).map((r) => html`<div class="li"><span class="f1"><b>${r.topic}</b> <span class="mu">${fmtDate(r.created_at)}</span>
      ${r.status === 'declined' && r.admin_note ? html`<br><span class="xs mu">${r.admin_note}</span>` : ''}</span>
      ${r.status === 'approved' && r.batch_id ? html`<a class="btn soft sm" href="/student/classes">See class</a>` : ''}${statusTag(r.status === 'approved' && !r.batch_id ? 'approved' : r.status)}</div>`)}</div>` : ''}</div>`;
}

register({
  'demo.ask': () => openModal({
    title: 'Ask for a free demo class',
    body: html`<form id="demo-ask" data-submit="demo.ask.send" novalidate>
      ${field('dm-topic', 'What would you like to try?', { name: 'topic', minlen: 2, maxlength: 160, ph: 'Selenium, SQL, API testing...' })}
      ${field('dm-note', 'Anything we should know? (days and times that suit you)', { name: 'note', rows: 3, req: false, max: 1000 })}</form>`,
    foot: html`<button type="button" class="btn ghost" data-act="modal.close">Cancel</button><button type="submit" form="demo-ask" class="btn">Send request</button>`,
  }),
  'demo.ask.send': (form) => submitForm(form, async ({ topic, note }) => {
    await api.post('/student/demo-requests', { body: { topic, note: note || '' } });
    closeModal(false);
    toast('Request sent. We will tell you when it is approved.', 'check');
    await reload();
  }, { onError: (error) => toast(error.message, 'alert') }),
});
